/* Interruptor de modo claro / oscuro.

   El estado inicial ya lo dejó puesto el script en línea del <head>, que
   corre antes del primer pintado. Este archivo sólo se encarga del clic y de
   mantener sincronizados los controles y la barra del navegador.

   Tres estados posibles en el atributo data-theme del <html>:
     ausente  — sigue al sistema operativo
     'light'  — el visitante eligió claro
     'dark'   — el visitante eligió oscuro

   Sin JavaScript el sitio se queda en el modo del sistema, que es la única
   opción que no depende de nosotros: por eso el botón se declara oculto en
   el marcado y este archivo lo revela.
*/
(function () {
  'use strict';

  var KEY = 'fw-color-mode';
  var root = document.documentElement;

  /* La elección de esta sesión, en memoria. localStorage puede fallar —modo
     privado, cuota llena, almacenamiento particionado— y si fuera la única
     fuente de verdad, un cambio de modo del sistema borraría un clic que
     acaba de ocurrir. */
  var chosen = null;
  var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  function systemMode() {
    return media && media.matches ? 'dark' : 'light';
  }

  function readStored() {
    try { return localStorage.getItem(KEY); }
    catch (e) {
      console.warn('[color-mode] no se pudo leer la preferencia guardada', e);
      return null;
    }
  }

  function currentMode() {
    var attr = root.getAttribute('data-theme');
    return attr === 'dark' || attr === 'light' ? attr : systemMode();
  }

  /* La barra del navegador en móvil.

     El layout emite dos etiquetas theme-color con media queries, y el
     navegador aplica la que coincide con el sistema, no la primera. Si aquí
     se escribiera solo una, con el sistema en oscuro y el visitante eligiendo
     claro la barra se quedaría verde sobre una página crema. Se escriben las
     dos: en cuanto hay JavaScript el modo lo decide el atributo, no la media
     query, así que ambas deben decir lo mismo.

     Si --bg no resuelve, la hoja no cargó o el token cambió de nombre. Se
     deja lo que puso el servidor en vez de tapar el problema con un color
     escrito a mano que envejecería con la paleta. */
  function syncBrowserChrome() {
    var metas = document.querySelectorAll('meta[name="theme-color"]');
    if (!metas.length) return;
    var bg = getComputedStyle(root).getPropertyValue('--bg').trim();
    if (!bg) {
      console.warn('[color-mode] --bg no resuelve; se conserva el theme-color del servidor');
      return;
    }
    for (var i = 0; i < metas.length; i++) metas[i].setAttribute('content', bg);
  }

  function syncControls(mode) {
    var next = mode === 'dark' ? 'light' : 'dark';
    var buttons = document.querySelectorAll('[data-color-mode-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      /* Antes convivían aria-pressed —estado actual— y una etiqueta que
         nombra el DESTINO. Un lector anunciaba «Cambiar a modo claro, botón,
         presionado» y no había forma de saber qué estaba presionado. La guía
         APG pide una cosa o la otra: aquí manda la etiqueta, porque es lo que
         la persona necesita para decidir si pulsa. Se quita el estado. */
      b.removeAttribute('aria-pressed');
      var label = b.getAttribute('data-label-' + next);
      if (label) b.setAttribute('aria-label', label);
      var sun = b.querySelector('[data-mode-icon="sun"]');
      var moon = b.querySelector('[data-mode-icon="moon"]');
      if (sun) sun.hidden = next !== 'light';
      if (moon) moon.hidden = next !== 'dark';
    }
  }

  function apply(mode, persist) {
    root.setAttribute('data-theme', mode);
    if (persist) {
      chosen = mode;
      try {
        localStorage.setItem(KEY, mode);
      } catch (e) {
        console.warn('[color-mode] la preferencia no se conservará al cambiar de página', e);
      }
    }
    syncControls(mode);
    syncBrowserChrome();
  }

  function reveal() {
    var buttons = document.querySelectorAll('[data-color-mode-toggle]');
    for (var i = 0; i < buttons.length; i++) buttons[i].hidden = false;
  }

  function onClick(event) {
    var button = event.target.closest && event.target.closest('[data-color-mode-toggle]');
    if (!button) return;
    event.preventDefault();
    apply(currentMode() === 'dark' ? 'light' : 'dark', true);
  }

  function init() {
    reveal();
    chosen = readStored();
    if (chosen !== 'dark' && chosen !== 'light') chosen = null;
    syncControls(currentMode());
    syncBrowserChrome();
    document.addEventListener('click', onClick);

    /* Si nunca eligió nada, el sitio debe seguir al sistema en vivo. */
    if (media && media.addEventListener) {
      media.addEventListener('change', function () {
        /* Solo se vuelve a seguir al sistema si nadie eligió nada. La
           elección en memoria manda sobre lo que diga el almacenamiento. */
        var stored = chosen || readStored();
        if (stored !== 'dark' && stored !== 'light') {
          root.removeAttribute('data-theme');
          syncControls(systemMode());
          syncBrowserChrome();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de temas reemplaza secciones sin recargar: hay que volver a
     revelar y sincronizar los botones que vienen en el marcado nuevo. */
  document.addEventListener('shopify:section:load', function () {
    reveal();
    syncControls(currentMode());
    syncBrowserChrome();
  });
})();
